module.exports = __webpack_public_path__ + "img/85-Montan Eiche Tabak - Chêne des Marais.jpg";